import { render, staticRenderFns } from "./ClassProperties.vue?vue&type=template&id=1cb22917&"
import script from "./ClassProperties.vue?vue&type=script&lang=ts&"
export * from "./ClassProperties.vue?vue&type=script&lang=ts&"
import style0 from "./ClassProperties.vue?vue&type=style&index=0&id=1cb22917&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports